import axios from "axios";

export async function logout(navigate) {
  let auth = localStorage.getItem("auth");
  let authObj = JSON.parse(auth);
  let userType = "ADMIN";
  let urlSeg = "/api/auth/";
  let navigateTo = "authentication/sign-in";
  if (authObj.terminalUser && authObj.terminalUser != null) {
    userType = "TERMINAL USER";
    urlSeg = "/api/terminal-auth/";
    navigateTo = "/terminal/authentication/sign-in/" + authObj.terminalUser.scCode;
  } else {
    userType = "ADMIN";
    urlSeg = "/api/auth/";
  }

  await axios.post(
    `${process.env.REACT_APP_API_URL}${urlSeg}logout`,
    {},
    { headers: { Authorization: `Bearer ${authObj.token}` } }
  );

  // Remove token + user info
  localStorage.removeItem("auth");
  //logout(navigate);

  // Redirect to login screen
  navigate(navigateTo, { replace: true });
}

export async function clearTokenAndRedirectToLogin(navigate) {
  let auth = localStorage.getItem("auth");
  let authObj = JSON.parse(auth);
  let userType = "ADMIN";
  let navigateTo = "/authentication/sign-in";
  if (authObj.terminalUser != null) {
    userType = "TERMINAL USER";
    navigateTo = "/terminal/authentication/sign-in";
  } else {
    userType = "ADMIN";
    urlSeg = "/api/auth/";
  }

  // Remove token + user info
  localStorage.removeItem("auth");
  // Redirect to login screen
  navigate(navigateTo, { replace: true });
}

export function getUserCategory() {
  let auth = localStorage.getItem("auth");
  let authObj = JSON.parse(auth);
  if (authObj == null) {
    return "ADMIN";
  }
  if (authObj.terminalUser != null) {
    return "TERMINAL USER";
  } else {
    return "ADMIN";
  }
}
